import { Link } from "react-router-dom";

export interface Crumb {
  label: string;
  to?: string;
}

interface BreadcrumbsProps {
  items: Crumb[];
}

export default function Breadcrumbs({ items }: BreadcrumbsProps) {
  return (
    <nav aria-label="面包屑导航" className="border-b border-background-200 bg-background-100">
      <ol className="mx-auto flex max-w-[1200px] flex-wrap items-center gap-2 px-4 py-3 font-label text-[12px] text-foreground-500 md:px-8">
        <li>
          <Link to="/" className="transition-colors hover:text-primary-600">首页</Link>
        </li>
        {items.map((item, index) => (
          <li key={`${item.label}-${index}`} className="flex items-center gap-2">
            <i className="ri-arrow-right-s-line text-foreground-300" aria-hidden="true"></i>
            {item.to && index < items.length - 1 ? (
              <Link to={item.to} className="transition-colors hover:text-primary-600">{item.label}</Link>
            ) : (
              <span className="text-foreground-800 line-clamp-1">{item.label}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}